import Leaderboard from './Leaderboard';
import './style.scss';

export default Leaderboard;
